import React, { useContext,useEffect } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import CartItem from "../../../styles/img/svg/CartItem";
import { Context } from "../../../_context/Store";
import { isMobile } from 'react-device-detect';


export default function VoucherItem(props) {
    const navigate = useNavigate();
    const [state, dispatch] = useContext(Context);
 
   
    return (
        <>
            <div className="sb-my-favourite-item" onClick={() => {
                dispatch({ type: 'FAV_BOX_TOGGLE', payload: true });
                navigate("/app/shop/" + props.id);
                // {isMobile && 
                //     window.location.reload();
                // }     

            }}>
                <div className="sb-my-favourite-item__name">
                    {props.favouriteName}
                </div>
                <div className="sb-my-favourite-item__right">
                    <div

                        className="sb-my-favourite-item__buy"
                    >
                        Buy
                    </div>
                    {/* <div className="sb-my-favourite-item__icon">
                        <CartItem />
                    </div> */}
                </div>
            </div>
        </>
    );
}
